import {Injectable, Inject} from '@angular/core';
import {Http, Headers, Response, RequestOptions} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from '../app.config';
import 'rxjs/add/observable/throw';

@Injectable()
export class ResourcesService {

  constructor(
    private http: Http, 
    @Inject(APP_CONFIG) private config: IAppConfig)
    { }

  resourcesList() {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    return this.http.get(this.config.apiEndpoint+'tasklist/get-alltasklist/id/asc', {headers: headers})
    .map(
        (res: Response) => {
            const user = res.json();
            return user;
        }
    )
    .catch(this.handleErrorObservable);
  }

  resourcesListbyid(associate_for) {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    return this.http.get(this.config.apiEndpoint+'tasklist/get-alltasklistbyid/id/asc/'+associate_for, {headers: headers})
    .map(
        (res: Response) => {
            const user = res.json();
            return user;
        }
    )
    .catch(this.handleErrorObservable);
  }

  private handleErrorObservable (error: Response | any) {
    return Observable.throw( error.json().error || 'Server Error' );
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/resources.service.ts